import React from 'react';
import styles from './SubMenu.module.css';

const SubMenu = (props) => {
    return (
        <div>
            <div className="inline lg:hidden" style={{width: '100%'}}>

            </div>
            <div className="hidden lg:inline">
                <div className={styles.root}>
                    <div className="wrapper wrapperContent" style={{paddingTop: 0, paddingBottom: 0}}>
                        <div className={styles.navMenu} style={{height: props.model.header ? 58 : 34}}>

                            <center>
                                <span className={styles.header}>{props.model.header}</span>
                                <table style={{borderSpacing: 0}} cellSpacing="0" cellPadding="0">
                                    <tbody>
                                    <tr>
                                        {props.model.items.map( item => (
                                        <td
                                          key={item.label}
                                          className={`${styles.navMenuItem} ${item.active ? styles.active : ''}`}
                                          onClick={item.onClick}
                                        >
                                          {item.label}
                                        </td>
                                        ))}
                                    </tr>

                                    </tbody>
                                </table>
                            </center>
                        </div>

                    </div>
                </div>
                <div style={{height: '50px'}}>
                </div>
            </div>

        </div>
    );
};

export default SubMenu;
